import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import BinTrf03Actions, { BinTrf03Types } from '../Stores/BinTrf03/Actions';

const getAppStore = state => state.app;

export function* binTrf03FetchBinTrf03({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(BinTrf03Actions.binTrf03FetchBinTrf03Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `binTrf/indexProcess/BIN_TRF_03/0/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        BinTrf03Actions.binTrf03FetchBinTrf03Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(BinTrf03Actions.binTrf03FetchBinTrf03Loading(false));
  }
}

export function* binTrf03CreateBinTrf03({ hdrIds }) {
  try {
    yield put(BinTrf03Actions.binTrf03CreateBinTrf03Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `binTrf/createProcess/PROD_RCPT`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(BinTrf03Actions.binTrf03CreateBinTrf03Success(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(BinTrf03Actions.binTrf03CreateBinTrf03Loading(false));
  }
}

export function* binTrf03GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/prodRcptDetail/update/${hdrId}`));
}

export function* binTrf03NewDocument() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/prodRcptDetail/create/${app.curDivisionId}`));
}

export const saga = [
  takeLatest(BinTrf03Types.BIN_TRF03_FETCH_BIN_TRF03, binTrf03FetchBinTrf03),
  takeLatest(BinTrf03Types.BIN_TRF03_CREATE_BIN_TRF03, binTrf03CreateBinTrf03),
  takeLatest(BinTrf03Types.BIN_TRF03_GO_TO_DOCUMENT, binTrf03GoToDocument),
  takeLatest(BinTrf03Types.BIN_TRF03_NEW_DOCUMENT, binTrf03NewDocument)
];
